<template>
  <div class="menu is-flex">
    <div class="menu-inner is-flex middle">
      <MenuItems />
      <Locations />
    </div>
    <LocationImage />
    <SocialLinks />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MenuItems from './menu/MenuItems.vue';
import Locations from './menu/Locations.vue';
import LocationImage from './menu/LocationImage.vue';
import SocialLinks from './menu/SocialLinks.vue';

export default {
  components: {
    MenuItems,
    Locations,
    LocationImage,
    SocialLinks,
  },
  computed: {
    ...mapGetters(['menuOpened']),
  },
};
</script>

<style lang="scss" scoped>
.menu {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 50;
  background: $color-primary;
  .menu__content {
    width: 100%;
    height: 100%;
  }
  .menu-inner {
    flex: 1;
    justify-content: space-between;
  }
}
</style>
